import { toast } from "react-toastify";

import {
  fetchBPRTwoRequest,
  fetchBPRTwoSuccess,
  fetchBPRTwoFailure,
} from "./reducer";

import { GET_ALL_BPR_TWO } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const getAllBPRTwo =
  (first = 10, offset = 1, startDate, endDate, setLoading) =>
  async (dispatch) => {
    dispatch(fetchBPRTwoRequest());

    try {
      setLoading?.(true);
      // ---------------------------------------------------------
      // API 1 - Revenue Summary
      // ---------------------------------------------------------

      const revenuePayload = {
        query: `query {
          revenueSummary(
            first: ${first},
            offset: ${offset},
            filter: {
              StartDate: "${startDate}",
              EndDate: "${endDate}"
            }
          ) {
            grossRevenue
            netRevenue
            averageRevenuePerStation
            partners {
              partnerId
              partnerName
              grossRevenue
              netRevenue
              averageRevenuePerStation
            }
          }
        }`,
      };

      const revenueResponse = await determineBaseUrlAndPerformApiCall(
        GET_ALL_BPR_TWO,
        "POST",
        revenuePayload,
      );

      if (revenueResponse?.error) {
        throw new Error(revenueResponse.error.message);
      }

      // ---------------------------------------------------------
      // API 2 - Unique Customers
      // ---------------------------------------------------------

      const customersPayload = {
        query: `query {
          uniqueCustomers(
            first: ${first},
            offset: ${offset},
            filter: {
              StartDate: "${startDate}",
              EndDate: "${endDate}"
            }
          ) {
            totalUniqueCustomers
            partners {
              partnerId
              partnerName
              uniqueCustomerCount
            }
          }
        }`,
      };

      const customersResponse = await determineBaseUrlAndPerformApiCall(
        GET_ALL_BPR_TWO,
        "POST",
        customersPayload,
      );

      if (customersResponse?.error) {
        throw new Error(customersResponse.error.message);
      }

      // ---------------------------------------------------------
      // API 3 - Session Uptime
      // ---------------------------------------------------------

      const uptimePayload = {
        query: `query {
          sessionUptime(
            first: ${first},
            offset: ${offset},
            filter: {
              StartDate: "${startDate}",
              EndDate: "${endDate}"
            }
          ) {
            totalUpTime
            uptimePercentage
            partners {
              partnerId
              partnerName
              totalUpTime
              uptimePercentage
            }
          }
        }`,
      };

      const uptimeResponse = await determineBaseUrlAndPerformApiCall(
        GET_ALL_BPR_TWO,
        "POST",
        uptimePayload,
      );

      if (uptimeResponse?.error) {
        throw new Error(uptimeResponse.error.message);
      }

      // ---------------------------------------------------------
      // API 4 - Session Summary
      // ---------------------------------------------------------

      const sessionPayload = {
        query: `query {
          sessionSummary(
            first: ${first},
            offset: ${offset},
            filter: {
              StartDate: "${startDate}",
              EndDate: "${endDate}"
            }
          ) {
            totalSessions
            totalKWh
            partners {
              partnerId
              partnerName
              sessionCount
              totalKWh
            }
          }
        }`,
      };

      const sessionResponse = await determineBaseUrlAndPerformApiCall(
        GET_ALL_BPR_TWO,
        "POST",
        sessionPayload,
      );

      if (sessionResponse?.error) {
        throw new Error(sessionResponse.error.message);
      }

      // ---------------------------------------------------------
      // Combine all 4 API responses
      // ---------------------------------------------------------

      const combinedData = {
        revenueSummary: revenueResponse?.data?.revenueSummary || {},

        uniqueCustomers: customersResponse?.data?.uniqueCustomers || {},

        sessionUptime: uptimeResponse?.data?.sessionUptime || {},

        sessionSummary: sessionResponse?.data?.sessionSummary || {},
      };

      dispatch(fetchBPRTwoSuccess(combinedData));
    } catch (error) {
      const message = error?.message || "Something went wrong";

      dispatch(fetchBPRTwoFailure(message));
      toast.error(message);
    } finally {
      setLoading?.(false);
    }
  };
